module.exports = "<p class=\"marginTop\">\n  Connecting the World of Creators!\n</p>\n"